module.exports = __webpack_public_path__ + "media/images/black-7e734ad75f912b6e136479985785874d.png";